import addHeader from './Api'
import { TEST } from '../../config/config'

const API_BASE = '/api/'

interface Module {
  idSubApp: number
  idApp: number
  appId: string
  moduleDescription: string
  id?: number
  configId?: string
  appInformation?: any
  moduleId?: number
}

export async function create(appData: Module) {
  const data = {
    appId: appData.appId,
    moduleDescription: appData.moduleDescription,
    test: TEST,
    active: true
  }
  return await fetch(API_BASE + 'module-post/' + appData.idApp + '/' + appData.idSubApp + '?companyId=1', {
    method: 'POST',
    headers: addHeader(),
    body: JSON.stringify(data)
  })
}

export async function update(appData: Module) {
  const data = {
    moduleId: appData.id,
    moduleDescription: appData.moduleDescription,
    test: TEST,
    configId: appData.configId,
    appId: appData.appId,
    active: true
  }
  return await fetch(API_BASE + 'module-put/' + appData.idApp + '/' + appData.idSubApp + '/' + appData.id + '?companyId=1', {
    method: 'PUT',
    headers: addHeader(),
    body: JSON.stringify(data)
  })
}

export async function archiveOne(appData: Module) {
  const data = {
    moduleId: appData.moduleId,
    moduleDescription: appData.moduleDescription,
    test: TEST,
    configId: appData.configId,
    appId: appData.appId,
    active: false
  }
  return await fetch(API_BASE + 'module-put/' + appData.appInformation.parents.idApp + '/' + appData.appInformation.parents.idSubApp + '/' + appData.moduleId + '?companyId=1', {
    method: 'PUT',
    headers: addHeader(),
    body: JSON.stringify(data)
  })
}

export async function deleteOne(id: number, idApp: number, idSubApp: number) {
  return await fetch(API_BASE + 'module-delete/' + idApp + '/' + idSubApp + '/' + id + '?companyId=1', {
    method: 'DELETE',
    headers: addHeader()
  })
}
